
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { xeroService } from '../../_services/xero.service';
import { Box, Grid2, TextField, Typography } from '@mui/material';
import { StandardButton } from '../../_components/button/primary.button';
import { useEffect, useState } from 'react';

export function XeroIndex() {
    const [status, setStatus] = useState("");

    useEffect(() => {
        fetchStatus();
    }, []);

    const fetchStatus = async () => {
        return await xeroService.getStatus()
            .then((json) => {
                setStatus(json)
            }, handleErrorResponse)
            .finally();
    };

    const connect = async () => {
        return await xeroService.getLoginUrl()
            .then((loginUrl) => {
                window.open(loginUrl, "_blank", "width=600,height=700");
            }, handleErrorResponse)
            .finally(() => { fetchStatus() });
    };

    return (
        <>
            <Grid2 container spacing={2} sx={{ "padding": "8px" }}>
                <Grid2 size={{ xs: 4 }}>
                    <StandardButton
                        icon="login"
                        variant="primary"
                        onClick={connect}>
                        Connect to Xero
                    </StandardButton>
                </Grid2>
            </Grid2>
            <Grid2 container spacing={2} sx={{ "padding": "8px" }}>
                <Grid2 size={{ xs: 6 }}>
                    <TextField
                        name="status"
                        label="Status"
                        fullWidth
                        multiline
                        rows={6}
                        value={status}
                    />
                </Grid2>
            </Grid2>
            <Grid2>
                <Typography
                    fontSize={{ xs: "12px", md: "15px" }}
                    marginTop={{ xs: "5px", sm: "5px", md: "10px" }}
                    marginBottom={{ xs: "0px", sm: "20px", lg: "0px" }}
                    fontFamily="Poppins, sans-serif"
                    fontWeight="300"
                >
                    <span style={{ fontWeight: "bold", fontStyle: "italic" }}>*Note: Xero returns time above in UTC.</span>
                </Typography>
            </Grid2>
        </>
    );
}


